import React from "react";
import img from "../assets/logo5.png";
import { AiFillGithub, AiFillLinkedin, AiOutlineArrowUp } from "react-icons/ai";

const Footer = () => {
  return (
    <footer>
      <div>
        <img src={img} alt="founder" />
        <h2>Pavan Kamthane</h2>
        <p>
          {/* a quote on life*/}
          "Life is like a box of chocolates. You never know what you're gonna
          get."
        </p>
      </div>
      <aside>
        <h2>Social Media</h2>
        <article>
          <a href="https://www.linkedin.com/in/pavankamthane/" target="blank">
            <AiFillLinkedin />
          </a>
          <a href="https://github.com/Pavan-Kamthane" target="blank">
            <AiFillGithub />
          </a>
        </article>
      </aside>
      <a href="#home">
        <AiOutlineArrowUp />
      </a>
    </footer>
  );
};

export default Footer;
